import { Type } from "class-transformer";
import { IsString, IsEnum, IsOptional, IsNotEmpty, IsUUID } from "class-validator";
import { CategoryTypes } from "../../utils/enums.utils";
import { SalesAttachmentsStatus, SalesQuarters, SalesStatus } from "../../interface/sales/sales-response.interface";
import { CreateSaleAttachmentsInterface, CreateSalesInterface, UpdateSaleAttachmentsInterface, UpdateSalesInterface } from "../../interface/sales/modify-sales.interface";

export class CreateSalesDto implements CreateSalesInterface {
  @IsEnum(SalesQuarters)
  quarter!: SalesQuarters;

  @IsEnum(SalesStatus)
  status!: SalesStatus;

  @IsEnum(CategoryTypes)
  category!: CategoryTypes;

  @IsOptional()
  @IsString()
  po_number!: string | null;

  @IsOptional()
  @IsString()
  invoice_number!: string | null;

  @IsOptional()
  @IsString()
  dr_number!: string | null;

  @IsOptional()
  @IsString()
  sales_remark!: string | null;

  @IsOptional()
  @IsString()
  created_by_id!: string | null;

  @IsOptional()
  @IsString()
  updated_by_id!: string | null;

  @IsUUID()
  @IsNotEmpty()
  monitoring_id!: string;
}

export class UpdateSalesDto implements UpdateSalesInterface {
  @IsUUID()
  @IsNotEmpty()
  id!: string;

  @IsOptional()
  @IsEnum(SalesQuarters)
  quarter?: SalesQuarters;

  @IsOptional()
  @IsEnum(SalesStatus)
  status?: SalesStatus;

  @IsOptional()
  @IsEnum(CategoryTypes)
  category?: CategoryTypes;

  @IsOptional()
  @IsString()
  po_number?: string | null;

  @IsOptional()
  @IsString()
  invoice_number?: string | null;

  @IsOptional()
  @IsString()
  dr_number?: string | null;

  @IsOptional()
  @IsString()
  sales_remark?: string | null;

  @IsOptional()
  @IsString()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  monitoring_id?: string;
}

export class CreateSaleAttachmentsDto implements CreateSaleAttachmentsInterface {
  @IsUUID()
  @IsNotEmpty()
  sales_id!: string;

  @IsUUID()
  @IsNotEmpty()
  attachment_id!: string;

  @IsEnum(SalesAttachmentsStatus)
  status!: SalesAttachmentsStatus;
}

export class UpdateSaleAttachmentsDto implements UpdateSaleAttachmentsInterface {
  @IsUUID()
  @IsNotEmpty()
  sales_id!: string;

  @IsUUID()
  @IsNotEmpty()
  attachment_id!: string;

  @IsEnum(SalesAttachmentsStatus)
  status!: SalesAttachmentsStatus;
}